import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';
import { getCurrentAccessToken } from 'utils/auth/authenticatedRequest';
import { UserPreferences } from 'utils/userPreferences';

const USER_PREFERENCES_URL = 'system/user_preferences';

let cachedUserPreferences: UserPreferences | null = null;
let cachedAccessToken: string | null = null;
let inFlightUserPreferencesRequest: Promise<UserPreferences> | null = null;
let inFlightAccessToken: string | null = null;

const getCachedAccessToken = () => getCurrentAccessToken();

const clearInFlightUserPreferencesRequest = (accessToken: string | null) => {
  if (inFlightAccessToken === accessToken) {
    inFlightUserPreferencesRequest = null;
    inFlightAccessToken = null;
  }
};

export const resetCurrentUserPreferencesCache = () => {
  cachedUserPreferences = null;
  cachedAccessToken = null;
  inFlightUserPreferencesRequest = null;
  inFlightAccessToken = null;
};

export const getCurrentUserPreferences = () => {
  const accessToken = getCachedAccessToken();

  if (cachedUserPreferences && cachedAccessToken === accessToken) {
    return Promise.resolve(cachedUserPreferences);
  }

  if (inFlightUserPreferencesRequest && inFlightAccessToken === accessToken) {
    return inFlightUserPreferencesRequest;
  }

  inFlightAccessToken = accessToken;
  inFlightUserPreferencesRequest = apiRequestHandlerPromise<UserPreferences>({
    url: USER_PREFERENCES_URL,
    method: 'GET',
  })
    .then((preferences) => {
      cachedUserPreferences = preferences;
      cachedAccessToken = accessToken;
      return preferences;
    })
    .finally(() => {
      clearInFlightUserPreferencesRequest(accessToken);
    });

  return inFlightUserPreferencesRequest;
};

export const updateCurrentUserPreferences = (preferences: Partial<UserPreferences>) => {
  const accessToken = getCachedAccessToken();

  return apiRequestHandlerPromise<UserPreferences>({
    url: USER_PREFERENCES_URL,
    method: 'POST',
    data: preferences,
  }).then((updatedPreferences) => {
    cachedUserPreferences = updatedPreferences;
    cachedAccessToken = accessToken;
    clearInFlightUserPreferencesRequest(accessToken);
    return updatedPreferences;
  });
};
